import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";
import storage from "@checkout/services/storage";
import Login from "./Forms/Login.vue";
import Register from "./Forms/Register.vue";
import SingleStep from "@checkout/components/Partials/SingleStep.vue";
import StepWrapper from "@checkout/components/Partials/StepWrapper.vue";
import stepsMixin from "@checkout/mixins/stepsMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [stepsMixin],

  components: {
    Login,
    Register,
    SingleStep,
    StepWrapper,
  },

  data() {
    return {
      disableStepContinue: true,
      skipJumping: false,
      showForm: false,
      hasAccount: false,
    };
  },

  computed: {
    ...mapGetters(["checkout", "steps", "isGeneralCheckout", "usePrepaidSteps"]),

    currentComponent() {
      return this.hasAccount ? "Login" : "Register";
    },
  },

  mounted() {
    this.prepareStep3();
  },

  methods: {
    setAccount(accountVar) {
      this.hasAccount = accountVar;
    },

    prepareStep3() {
      api
        .get("/public-api/prepare/3/" + localStorage.get("page-step", true))
        .then(() => {
          this.disableStepContinue = false;
        })
        .catch((error) => {
          localStorage.save("token", "", true);
          this.$swal(this.$i18nApi.t("messages.error"));
          if (error.response.data.hasOwnProperty("page")) {
            router.push("/checkout/" + error.response.data.page);
          } else {
            router.push("/checkout/1");
          }
        });
    },

    proceedToNextStep() {
      this.$refs.childComponent.submitData();
    },
  },

  beforeRouteLeave(to, from, next) {
    if (!this.skipJumping) {
      storage.save(
        "page-step",
        window.location.pathname.split("/").pop(),
        true
      );
    }

    next();
  },
};
